export const API_BASE_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : '';

export const API_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export const apiPath = {
  // Which release the API runs — signed-in users only (VersionController).
  VERSION: {
    method: API_METHOD.GET,
    path: '/api/version',
  },
  AGE_CATEGORIES: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/age_categories',
    },
  },
  ASSOCIATIONS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/associations',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/associations',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/associations/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/associations/{id}',
    },
  },
  APPLICATIONS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/applications',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/applications',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/applications/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/applications/{id}',
    },
  },
  CATEGORY_WORKSPACE: {
    OVERVIEW: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competition}/categories/{category}/overview',
    },
  },
  DRAW_WORKFLOW: {
    SWAP: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/draw/swap',
    },
    RESET: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/draw/reset',
    },
    APPROVE: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/draw/approve',
    },
    REOPEN: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/draw/reopen',
    },
    CHANGES: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competition}/categories/{category}/draw/changes',
    },
    // «Сітку роздруковано» (17 Oct 2026).
    PRINTED: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/draw/printed',
    },
  },
  CATEGORY_CORRECTION: {
    START: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/correction/start',
    },
    RESET_RESULTS: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/correction/reset-results',
    },
    REGENERATE_OFFICIAL_RESULTS: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/correction/regenerate-official-results',
    },
    FINISH: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/correction/finish',
    },
  },
  COMPETITION_RESULT: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competition_results',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/competition_results/{id}',
    },
    SCORE: {
      method: API_METHOD.POST,
      path: '/api/competition_results/{id}/score',
    },
    SCORE_TIE_BREAK: {
      method: API_METHOD.POST,
      path: '/api/competition_results/{id}/score-tie-break',
    },
    ROUND_COMPLETE: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/rounds/{round}/complete',
    },
    // Publishing the official protocol of a category.
    OFFICIAL_RESULTS_CONFIRM: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/official-results/confirm',
    },
    ROUND_REOPEN: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/rounds/{round}/reopen',
    },
    POINTS_STAGE_RESET: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/points-stage/reset',
    },
    WINNER: {
      method: API_METHOD.POST,
      path: '/api/competition_results/{id}/winner',
    },
    DRAW: {
      method: API_METHOD.POST,
      path: '/api/competitions/draw',
    },
    DRAW_DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/competitions/draw',
    },
  },
  COMPETITION_CATEGORY: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competition_categories',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/competition_categories/{id}',
    },
    DRAW: {
      method: API_METHOD.POST,
      path: '/api/competition_categories/{id}/draw',
    },
    DRAW_DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/competition_categories/{id}/draw',
    },
    // «Категорія не проводилася» — recorded, and taken back, by the chief
    // secretary. One path, two methods, like every other flag here.
    // Which categories get their own sheet in the MSAC consolidated report
    // (MsacConsolidatedReportController) — the whole choice in one request.
    MSAC_CONSOLIDATED: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competition}/msac-consolidated-categories',
    },
    NOT_HELD: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/categories/{category}/not-held',
    },
    NOT_HELD_CLEAR: {
      method: API_METHOD.DELETE,
      path: '/api/competitions/{competition}/categories/{category}/not-held',
    },
  },
  COMPETITIONS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competitions',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/competitions',
    },
    GET: {
      method: API_METHOD.GET,
      path: '/api/competitions/{id}',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/competitions/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/competitions/{id}',
    },
    GENERATE_ALL_DRAWS: {
      method: API_METHOD.POST,
      path: '/api/competitions/{id}/generate-all-draws',
    },
    // Where the draws stand: categories with participants, drawn, approved.
    DRAW_STATUS: {
      method: API_METHOD.GET,
      path: '/api/competitions/{id}/draw-status',
    },
    // Which protocol each drawn category will run at the mat.
    PROTOCOL_READINESS: {
      method: API_METHOD.GET,
      path: '/api/competitions/{id}/protocol-readiness',
    },
    // The readiness checklist: draws, schedule, mats, displays, officials.
    READINESS: {
      method: API_METHOD.GET,
      path: '/api/competitions/{id}/readiness',
    },
    // Whether every category's result is confirmed — the Reports tab's
    // indicator. A different question from READINESS above, asked at the
    // other end of the competition day.
    RESULTS_READINESS: {
      method: API_METHOD.GET,
      path: '/api/competitions/{id}/results-readiness',
    },
    ASSIGN_NUMBERS: {
      method: API_METHOD.POST,
      path: '/api/competitions/{id}/assign-numbers',
    },
  },
  COMPETITION_SPORTSMEN: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competition-sportsmen',
    },
  },
  COMPETITION_SECRETARIES: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competition_secretaries',
  },
    POST: {
      method: API_METHOD.POST,
      path: '/api/competition_secretaries',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/competition_secretaries/{id}',
    },
  },
  // The judges of a competition (17 Oct 2026) — any number, a chief, a deputy.
  COMPETITION_REFEREES: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competition_referees',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/competition_referees',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/competition_referees/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/competition_referees/{id}',
    },
  },
  FEES: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competition_fees',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/competition_fees',
    },
    GET: {
      method: API_METHOD.GET,
      path: '/api/competition_fees/{id}',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/competition_fees/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/competition_fees/{id}',
    },
  },
  FEE_ITEMS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competition_fee_lists',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/competition_fee_lists',
    },
  },
  // The zones a competition's form offers, and its city's (VenueTimezoneController, 4 Nov 2026).
  VENUE_TIMEZONES: {
    method: API_METHOD.GET,
    path: '/api/venue-timezones',
  },
  LOCATIONS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/locations',
    },
    // «Вже в системі» and «Знайдено на GeoNames» (LocationSearchController, 18 Oct 2026).
    SEARCH: {
      method: API_METHOD.GET,
      path: '/api/location-search',
    },
    // A GeoNames place with its country and region.
    IMPORT: {
      method: API_METHOD.POST,
      path: '/api/location-import',
    },
    // A place's English and Ukrainian names, pulled from GeoNames again.
    NAMES: {
      method: API_METHOD.POST,
      path: '/api/location-names',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/locations',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/locations/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/locations/{id}',
    },
  },
  PARTICIPANT: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competition_participants',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/competition_participants',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/competition_participants/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/competition_participants/{id}',
    },
    // The mandate commission's correction: an athlete entered in the wrong
    // category. Its own route rather than the PATCH above, because it is one
    // operation with its own rules (both categories must be undrawn) and its
    // own audit entry — and because it can also COPY rather than move.
    MOVE_CATEGORY: {
      method: API_METHOD.POST,
      path: '/api/competition-participants/{id}/category',
    },
  },
  PROFILES: {
    // Which user each profile belongs to — the super admin's «Користувач»
    // column (1 Nov 2026): {profileId: {username, active}}.
    LINKED_USERS: {
      method: API_METHOD.GET,
      path: '/api/profiles/linked-users',
    },
    // Groups of profiles that are the same person. SUPER_ADMIN only — merging
    // rewrites competition history, so the screen that decides it is gated at
    // the same level as the correction workflow.
    DUPLICATES: {
      method: API_METHOD.GET,
      path: '/api/profiles/duplicates',
    },
    // Several copies of one person become one. The backend proves inside its
    // own transaction that no already-printed protocol changes, and refuses
    // naming the field and the date if one would.
    MERGE: {
      method: API_METHOD.POST,
      path: '/api/profiles/merge',
    },
    GET: {
      method: API_METHOD.GET,
      path: '/api/profiles/{id}',
    },
    LIST: {
      method: API_METHOD.GET,
      path: '/api/profiles',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/profiles',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/profiles/{id}',
    },
    // Whether a profile may be deleted, and why not (21 Oct 2026).
    DELETABILITY: {
      method: API_METHOD.GET,
      path: '/api/profiles/{id}/deletability',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/profiles/{id}',
    },
    SHARED_USERS: {
      LIST: {
        method: API_METHOD.GET,
        path: '/api/profiles/{id}/shared-users',
      },
      ADD: {
        method: API_METHOD.POST,
        path: '/api/profiles/{id}/shared-users',
      },
      REMOVE: {
        method: API_METHOD.DELETE,
        path: '/api/profiles/{id}/shared-users/{userId}',
      },
    },
  },
  QUALIFICATIONS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/qualifications',
    },
    // A federation's ranks and categories, edited on «Налаштування → Дисципліни» (18 Oct 2026).
    POST: {
      method: API_METHOD.POST,
      path: '/api/qualifications',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/qualifications/{id}',
    },
  },
  CLUBS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/clubs',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/clubs',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/clubs/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/clubs/{id}',
    },
  },
  RANKS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/ranks',
    },
  },
  // How long a kumite bout lasts (kumite and the kumite rounds of fukugo).
  // The level a competition is rated at and the tables it gives
  // (CompetitionRatingPointsController) — MSAC, 15 Oct 2026.
  RATING_POINTS: {
    GET: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/rating-points',
    },
    SAVE: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competitionId}/rating-points',
    },
  },
  // A competition's line on its PRINTED brackets (CompetitionBracketLineController, 18 Oct 2026).
  BRACKET_LINE: {
    GET: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/bracket-line',
    },
    SAVE: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competitionId}/bracket-line',
    },
    // First-round widths and font size of the printed sheets (BracketSheet).
    SHEET: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competitionId}/bracket-sheet',
    },
  },
  // The Додаток 10 column a competition's places are scored by
  // (CompetitionPlacePointsController) — MSAC, 17 Oct 2026.
  // The server's load for the chief secretary (ServerHealthController, 4 Nov 2026).
  SERVER_HEALTH: {
    method: API_METHOD.GET,
    path: '/api/competitions/{competitionId}/server-health',
  },
  // Б-5 / Б-6 judges' ranges per age group (CompetitionMsacScoreRangesController, 4 Nov 2026).
  MSAC_SCORE_RANGES: {
    GET: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/msac-score-ranges',
    },
    SAVE: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competitionId}/msac-score-ranges',
    },
  },
  PLACE_POINTS: {
    GET: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/place-points',
    },
    SAVE: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competitionId}/place-points',
    },
  },
  // THE PARTICIPANTS' MONITOR (29 Oct 2026): how athletes are named on it and
  // the QR codes printed for the hall — chief secretary.
  MONITOR: {
    SHOW: { method: API_METHOD.GET, path: '/api/competitions/{competitionId}/monitor' },
    SETTINGS_SAVE: { method: API_METHOD.PUT, path: '/api/competitions/{competitionId}/monitor/settings' },
    ACCESS_CREATE: { method: API_METHOD.POST, path: '/api/competitions/{competitionId}/monitor/accesses' },
    ACCESS_REVOKE: { method: API_METHOD.POST, path: '/api/monitor-accesses/{id}/revoke' },
    ACCESS_QR: { method: API_METHOD.GET, path: '/api/monitor-accesses/{id}/qr.svg' },
    ACCESS_POSTER: { method: API_METHOD.GET, path: '/api/monitor-accesses/{id}/poster' },
    // The phone's — anonymous, the token is the credential.
    PUBLIC: { method: API_METHOD.GET, path: '/api/public/monitor/{token}' },
    // «Сповіщати» — this browser's Web Push subscription (phase 5).
    PUSH_SUBSCRIBE: { method: API_METHOD.PUT, path: '/api/public/monitor/{token}/push' },
    PUSH_UNSUBSCRIBE: { method: API_METHOD.DELETE, path: '/api/public/monitor/{token}/push' },
  },
  // THE PUBLISHED SCHEDULE (29 Oct 2026) — the chief secretary publishes,
  // anybody reads.
  // THE SHOOTING SCHEDULE (2 Nov 2026) — relays by application, published apart.
  SHOOTING_SCHEDULE: {
    SHOW: { method: API_METHOD.GET, path: '/api/competitions/{competitionId}/shooting-schedule' },
    SAVE: { method: API_METHOD.PUT, path: '/api/competitions/{competitionId}/shooting-schedule' },
    OWN_WEAPON: { method: API_METHOD.PUT, path: '/api/competitions/{competitionId}/shooting-schedule/own-weapon' },
    SHOOTING: { method: API_METHOD.PUT, path: '/api/competitions/{competitionId}/shooting-schedule/shooting' },
    PUBLISH: { method: API_METHOD.POST, path: '/api/competitions/{competitionId}/shooting-schedule/publication' },
    WITHDRAW: { method: API_METHOD.DELETE, path: '/api/competitions/{competitionId}/shooting-schedule/publication' },
    PRINT: { method: API_METHOD.GET, path: '/api/reports/competitions/{competition}/shooting-relays' },
    // Anybody's — no login.
    PUBLIC: { method: API_METHOD.GET, path: '/api/public/schedule/{competitionId}/shooting' },
  },
  SCHEDULE_PUBLICATION: {
    SHOW: { method: API_METHOD.GET, path: '/api/competitions/{competitionId}/schedule-publication' },
    PUBLISH: { method: API_METHOD.POST, path: '/api/competitions/{competitionId}/schedule-publication' },
    WITHDRAW: { method: API_METHOD.DELETE, path: '/api/competitions/{competitionId}/schedule-publication' },
    QR: { method: API_METHOD.GET, path: '/api/competitions/{competitionId}/schedule-publication/qr.svg' },
    // Anybody's — no login.
    PUBLIC: { method: API_METHOD.GET, path: '/api/public/schedule/{competitionId}' },
    // Who is in which category — the public page's search.
    PUBLIC_ATHLETES: { method: API_METHOD.GET, path: '/api/public/schedule/{competitionId}/athletes' },
    // Who performs in a category — the card's hover, named as the monitor names them.
    PUBLIC_CATEGORY: { method: API_METHOD.GET, path: '/api/public/schedule/{competitionId}/categories/{categoryId}' },
  },
  BOUT_DURATION: {
    // The competition's table, per age category — chief secretary.
    TABLE: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/bout-durations',
    },
    TABLE_SAVE: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competitionId}/bout-durations',
    },
    // One category — the mat before its first bout, the chief secretary any time.
    CATEGORY: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/categories/{categoryId}/bout-duration',
    },
    CATEGORY_SAVE: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competitionId}/categories/{categoryId}/bout-duration',
    },
  },
  // The MSAC mat's regulation (1 Nov 2026) — the competition's table and a
  // category's rounds × length; the federation's is DISCIPLINES.MAT_REGULATION_*.
  MSAC_BOUT_DURATION: {
    TABLE: { method: API_METHOD.GET, path: '/api/competitions/{competitionId}/msac-bout-durations' },
    TABLE_SAVE: { method: API_METHOD.PUT, path: '/api/competitions/{competitionId}/msac-bout-durations' },
    CATEGORY: { method: API_METHOD.GET, path: '/api/competitions/{competitionId}/categories/{categoryId}/msac-bout-duration' },
    CATEGORY_SAVE: { method: API_METHOD.PUT, path: '/api/competitions/{competitionId}/categories/{categoryId}/msac-bout-duration' },
  },
  // A round robin's table: the fights' points and penalties, and the judges'
  // order for athletes nothing else separates.
  ROUND_ROBIN: {
    TABLE: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/categories/{categoryId}/round-robin',
    },
    FIGHT: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competitionId}/categories/{categoryId}/round-robin/fights/{pair}',
    },
    ORDER: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competitionId}/categories/{categoryId}/round-robin/order',
    },
  },
  // Bunkai on or off for one team kata category — performed in the final only.
  BUNKAI: {
    CATEGORY: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/categories/{categoryId}/bunkai',
    },
    CATEGORY_SAVE: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competitionId}/categories/{categoryId}/bunkai',
    },
  },
  HISTORY: {
    // Generic historized-field timeline (admin-only; newest first):
    // params { entity: 'profile', id: <uuid>, field: 'rank' }.
    LIST: {
      method: API_METHOD.GET,
      path: '/api/history',
    },
    // Which historized fields of one subject changed (admin-only):
    // params { entity: 'profile', id: <uuid> } → [{ field, count, lastChangedAt }].
    FIELDS: {
      method: API_METHOD.GET,
      path: '/api/history/fields',
    },
    // Admin validity-period correction — body { validFrom, validTo|null }.
    PATCH_PERIOD: {
      method: API_METHOD.PATCH,
      path: '/api/history/{id}',
    },
    // SUPER-ADMIN only (backend-enforced): permanent record deletion.
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/history/{id}',
    },
  },
  REFEREE: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/referees',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/referees',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/referees/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/referees/{id}',
    },
  },
  REPORTS: {
    APPLICATION_PARTICIPANTS: {
      method: API_METHOD.GET,
      path: '/api/reports/applications/{id}/participants',
    },
    // One application across the author's competitions on overlapping
    // dates: the list to tick from, and the combined PDF (?with=id,id).
    APPLICATION_COMBINABLE: {
      method: API_METHOD.GET,
      path: '/api/reports/applications/{id}/combinable',
    },
    APPLICATION_COMBINED: {
      method: API_METHOD.GET,
      path: '/api/reports/applications/{id}/combined',
    },
    COMPETITION_RESULT: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/category/{category}/result',
    },
    // A category's participants with place, weight and grades (2 Nov 2026).
    CATEGORY_PARTICIPANTS: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/category/{category}/participants',
    },
    COMPETITION_ALL_CATEGORY_RESULTS: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/category-result-reports/download',
    },
    COMPETITION_CATEGORIES: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/categories_report',
    },
    COMPETITION_PROTOCOL: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/protocol',
    },
    COMPETITION_MANDATE_COMMISSION_PROTOCOL: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/mandate_commission_protocol',
    },
    COMPETITION_SPORTSMEN: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/sportsmen',
    },
    COMPETITION_TEAM_RANKS: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/team_ranks',
    },
    COMPETITION_CLUB_RANKS: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/club_ranks',
    },
    // «Зведений командний / клубний рейтинг» (12 Oct 2026).
    COMPETITION_CONSOLIDATED: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/consolidated',
    },
    COMPETITION_CONSOLIDATED_RANKS: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/consolidated_{kind}_ranks',
    },
    COMPETITION_TRAINER: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/trainer',
    },
    COMPETITION_MSAC_FINAL_PROTOCOL: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/msac_final_protocol',
    },
    // The same protocol as an Excel workbook, in the federation's «Свод» layout.
    COMPETITION_MSAC_FINAL_PROTOCOL_XLSX: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/msac_final_protocol.xlsx',
    },
    // «Звіт керівника делегації» — the Ministry's form, filled (16 Oct 2026).
    COMPETITION_MSAC_DELEGATION_REPORT: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/msac_delegation_report.xlsx',
    },
    // Blank forms (Reports tab → Бланки): the list is the competition's
    // discipline's own, decided by the backend (BlankFormRegistry).
    COMPETITION_BLANKS: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/blanks',
    },
    COMPETITION_BLANK: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/blanks/{code}',
    },
    // «Звіт головної суддівської колегії»: the fields (computed + typed),
    // saving what was typed, and the editable Word document.
    COMPETITION_CHIEF_JUDGE_REPORT: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/chief_judge_report',
    },
    COMPETITION_CHIEF_JUDGE_REPORT_SAVE: {
      method: API_METHOD.PUT,
      path: '/api/reports/competitions/{competition}/chief_judge_report',
    },
    COMPETITION_CHIEF_JUDGE_REPORT_DOCX: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/chief_judge_report/docx',
    },
    // «Оперативний звіт» for the Ministry of Youth and Sports (10 Oct 2026).
    COMPETITION_MINISTRY_REPORT: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/ministry_report',
    },
    COMPETITION_MINISTRY_REPORT_SAVE: {
      method: API_METHOD.PUT,
      path: '/api/reports/competitions/{competition}/ministry_report',
    },
    COMPETITION_MINISTRY_REPORT_DOCX: {
      method: API_METHOD.GET,
      path: '/api/reports/competitions/{competition}/ministry_report/docx',
    },
  },
  MSAC_FINAL_RESULTS: {
    GET: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competition}/msac-final-results',
    },
  },
  CATEGORY_SHOOTING_TIE_BREAKS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/category-shooting-tie-breaks',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/category-shooting-tie-breaks',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/category-shooting-tie-breaks/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/category-shooting-tie-breaks/{id}',
    },
  },
  SHOOTING_RESULTS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competition-shooting-results',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/competition-shooting-results',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/competition-shooting-results/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/competition-shooting-results/{id}',
    },
  },
  // Competition Operations — the tatami floor. {braces} are substituted by
  // requestApiPath, matching the SCHEDULE block below.
  OPERATIONS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/operations',
    },
    PROVISION: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competitionId}/operations/provision',
    },
    // The A4s to print before the competition (3 Nov 2026).
    POSTER_MAT_PHONE: { method: API_METHOD.GET, path: '/api/competitions/{competitionId}/posters/mat-phone' },
    POSTER_SCHEDULE: { method: API_METHOD.GET, path: '/api/competitions/{competitionId}/posters/schedule' },
    // A pairing page as a QR code — kind: phone | display (3 Nov 2026).
    DEVICE_PAIRING_QR: {
      method: API_METHOD.GET,
      path: '/api/device-pairing/{kind}/qr.svg',
    },
    // What the mats started or ran, by category — the schedule's editor locks it (3 Nov 2026).
    FLOOR_STATES: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/operations/floor-states',
    },
    // «Узгодити з розкладом» (3 Nov 2026) — answers {sessions, summary}.
    SCHEDULE_SYNC: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competitionId}/operations/schedule-sync',
    },
    ASSIGNABLE_SECRETARIES: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/operations/secretaries',
    },
    // A secretary's six-digit PIN for the phone — answered once, never again.
    SECRETARY_PIN: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competitionId}/operations/secretaries/{secretaryId}/pin',
    },
    // Taken back — the phones signed in with it are signed out (3 Nov 2026).
    SECRETARY_PIN_REVOKE: {
      method: API_METHOD.DELETE,
      path: '/api/competitions/{competitionId}/operations/secretaries/{secretaryId}/pin',
    },
    // Fresh PINs, printed as cards to cut — { secretaryIds? } (3 Nov 2026).
    PIN_CARDS: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competitionId}/posters/pin-cards',
    },
    // The competition's judges a mat may be given as referee or arbiter (17 Oct 2026).
    ASSIGNABLE_JUDGES: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/operations/judges',
    },
    ASSIGN_JUDGES: {
      method: API_METHOD.POST,
      path: '/api/tatami-sessions/{id}/judges',
    },
    ASSIGN_SECRETARY: {
      method: API_METHOD.POST,
      path: '/api/tatami-sessions/{id}/secretary',
    },
    SESSION_TRANSITION: {
      method: API_METHOD.POST,
      path: '/api/tatami-sessions/{id}/{transition}',
    },
    QUEUE_ORDER: {
      method: API_METHOD.POST,
      path: '/api/tatami-sessions/{id}/queue/order',
    },
    // The fight to run now, out of the bracket's order (7 Oct 2026).
    CURRENT_FIGHT: {
      method: API_METHOD.POST,
      path: '/api/tatami-sessions/{id}/current-fight',
    },
    ITEM_TRANSITION: {
      method: API_METHOD.POST,
      path: '/api/tatami-queue-items/{id}/{transition}',
    },
    // «Сітка на татамі» — the chief secretary's tick (4 Nov 2026).
    BRACKET_AT_MAT: {
      method: API_METHOD.POST,
      path: '/api/tatami-queue-items/{id}/bracket-at-mat',
    },
    BRACKETS_BY_CHIEF: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competitionId}/operations/brackets-by-chief',
    },
    SUBSCRIPTION: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/realtime/subscription',
    },
    WORKSPACE: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/tatamis/{day}/{tatamiNumber}/workspace',
    },
    ITEM_MOVE: {
      method: API_METHOD.POST,
      path: '/api/tatami-queue-items/{id}/move',
    },
  },
  // PROTESTS against a fight (25 Oct 2026) — FSKA Розділ VII, MSAC IX.
  // The mat's secretary registers, the chief secretary decides.
  // Why each athlete of a category stands above the next (27 Oct 2026).
  DECISION_PROTOCOL: {
    GET: { method: API_METHOD.GET, path: '/api/competitions/{competitionId}/categories/{categoryId}/decision-protocol' },
  },
  // THE SHOOTING SECRETARY of a competition (27 Oct 2026).
  SHOOTING_SECRETARY: {
    PANEL: { method: API_METHOD.GET, path: '/api/competitions/{competitionId}/shooting-secretaries' },
    ASSIGN: { method: API_METHOD.POST, path: '/api/competition-shooting-secretaries' },
    REMOVE: { method: API_METHOD.DELETE, path: '/api/competition-shooting-secretaries/{id}' },
  },
  PROTEST: {
    LIST: { method: API_METHOD.GET, path: '/api/competitions/{competitionId}/protests' },
    REGISTER: { method: API_METHOD.POST, path: '/api/competitions/{competitionId}/protests' },
    FIGHTS: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/categories/{categoryId}/protest-fights',
    },
    DECIDE: { method: API_METHOD.POST, path: '/api/protests/{id}/decision' },
    // Stage two — the written form handed in (25 Oct 2026).
    FILE: { method: API_METHOD.POST, path: '/api/protests/{id}/filing' },
    // Who may have filed it — the application's representatives, the coaches, the competition's.
    REPRESENTATIVES: { method: API_METHOD.GET, path: '/api/competitions/{competitionId}/protest-representatives' },
  },
  // Fight protocols — the secretary's hands on a live fight.
  FIGHT_PROTOCOL: {
    OPEN: { method: API_METHOD.POST, path: '/api/fight-protocols' },
    GET: { method: API_METHOD.GET, path: '/api/fight-protocols/{id}' },
    // Every protocol of one category, read-only — the bracket screen's review
    // of what happened at the mat, and how it knows a fight is already decided
    // by a sheet.
    FOR_CATEGORY: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competition}/categories/{category}/fight-protocols',
    },
    // Which fight the mat running the category is on now and runs next.
    MAT_FIGHTS: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competition}/categories/{category}/mat-fights',
    },
    TRANSITION: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/{transition}' },
    SCORE: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/score' },
    PENALTY: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/penalty' },
    // Правила Розділ VIII §14-16 — хіківаке, енчо-сен, хантей. Three separate
    // routes rather than one "decision" endpoint with a mode, because they are
    // three different acts of the judging panel and each refuses for its own
    // reason.
    DRAW: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/draw' },
    ENCHO_SEN: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/encho-sen' },
    HANTEI: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/hantei' },
    // start | pause | resume | stop. The browser sends an intent; the server
    // owns the clock and answers with the anchor to animate against.
    TIMER: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/timer/{action}' },
    FUKUGO_WINNER: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/fukugo/winner' },
    FLAG_WINNER: {
      method: API_METHOD.POST,
      path: '/api/fight-protocols/{id}/winner',
    },
    KATA_SCORE: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/kata/score' },
    // БУНКАЙ — the second half of a TEAM kata result, scored by the same panel.
    KATA_BUNKAI: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/kata/bunkai' },
    // Kata is performed ONE AT A TIME; this is who is on the mat right now, and
    // it is what the public display shows instead of the whole table.
    KATA_PERFORMER: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/kata/performer' },
    // The score range the judging panel announced for this round (Розділ X
    // §2.2) — it sets the BASE the five judges start from.
    KATA_RANGE: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/kata/range' },
    // Which kata the athlete is performing (Розділ X §2.9) — chosen from the
    // competition's own list.
    KATA_NAME: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/kata/name' },
    KATA_JUDGES: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/kata/judges' },

    KATA_TIE_BREAK: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/kata/tie-break' },
    MSAC_JUDGES: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/msac/judges' },
    MSAC_ACTION: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/msac/action' },
    MSAC_INFRACTION: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/msac/infraction' },
    // Time out of the bout, per athlete (2 Nov 2026).
    MSAC_TIMEOUT_START: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/msac/timeout/start' },
    MSAC_TIMEOUT_STOP: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/msac/timeout/stop' },
    MSAC_LATENESS: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/msac/lateness' },
    MSAC_JUDGE_TOTALS: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/msac/judge-totals' },
    // The arbiter's ruling on the class when the winning notes disagree (26 Oct 2026).
    MSAC_ARBITER_CLASS: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/msac/arbiter-class' },
    MSAC_CLEAN_WIN: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/msac/clean-win' },
    // Round 1 → the minute of rest → round 2 (Розділ X). No payload: WHICH
    // part comes next is the backend's answer, not the panel's.
    MSAC_PERIOD: { method: API_METHOD.POST, path: '/api/fight-protocols/{id}/msac/period' },
  },
  // The ONLY endpoint a public screen touches. Anonymous, GET, one mat.
  // A PHONE AT THE MAT — anonymous like a screen, but its token writes the
  // current kumite bout of its own mat (MatPhoneController).
  // The token goes in the X-Mat-Phone-Token header, never in the path.
  MAT_PHONE: {
    GET: {
      method: API_METHOD.GET,
      path: '/api/public/mat-phone',
    },
    ACTION: {
      method: API_METHOD.POST,
      path: '/api/public/mat-phone/{action}',
    },
  },
  PUBLIC_DISPLAY: {
    GET: {
      method: API_METHOD.GET,
      path: '/api/public/displays/{token}',
    },
    // The screen unpairs itself (3 Nov 2026).
    RELEASE: {
      method: API_METHOD.POST,
      path: '/api/public/displays/{token}/release',
    },
    // Pairing. Both anonymous: a screen fresh out of a box has no identity,
    // which is the reason pairing exists at all.
    PAIR_START: {
      method: API_METHOD.POST,
      path: '/api/public/displays/pair',
    },
    PAIR_POLL: {
      method: API_METHOD.GET,
      path: '/api/public/displays/pair/{secret}',
    },
    // Operator side. Authenticated: listing needs a secretary, claiming needs
    // the chief secretary.
    PAIR_PENDING: {
      method: API_METHOD.GET,
      path: '/api/display-pairings',
    },
    PAIR_CLAIM: {
      method: API_METHOD.POST,
      path: '/api/display-pairings/{code}/claim',
    },
    // The screens already placed, and the two things the floor can do to one.
    // DEVICES needs a secretary; MOVE and RELEASE need the chief secretary,
    // because which mat a screen shows is what the hall is told.
    DEVICES: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competition}/displays',
    },
    MOVE: {
      method: API_METHOD.POST,
      path: '/api/tatami-displays/{id}/mat',
    },
    RELEASE: {
      method: API_METHOD.POST,
      path: '/api/tatami-displays/{id}/release',
    },
    // Which half of THIS screen the red corner takes. Per device: two
    // televisions at one tatami can face each other across the mat.
    LAYOUT: {
      method: API_METHOD.POST,
      path: '/api/tatami-displays/{id}/layout',
    },
    // The language THIS screen speaks — 'ua', 'en' or null (its browser's).
    LOCALE: {
      method: API_METHOD.POST,
      path: '/api/tatami-displays/{id}/locale',
    },
    // How often the mats' screens read during a bout — { livePollMs } (3 Nov 2026).
    REFRESH_GET: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/display-refresh',
    },
    REFRESH_SET: {
      method: API_METHOD.PUT,
      path: '/api/competitions/{competitionId}/display-refresh',
    },
    // Is the real-time hub there, and does it deliver (RealTimeCheckController, 4 Nov 2026).
    REALTIME_CHECK: {
      method: API_METHOD.GET,
      path: '/api/competitions/{competitionId}/realtime-check',
    },
    REALTIME_CHECK_SEND: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competitionId}/realtime-check',
    },
  },
  ATTENDANCE: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competition-attendances',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/competition-attendances',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/competition-attendances/{id}',
    },
    BULK: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/attendance/bulk',
    },
    NATIONAL_TEAM_BULK: {
      method: API_METHOD.POST,
      path: '/api/competitions/{competition}/attendance/national-team/bulk',
    },
  },
  DISCIPLINES: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/disciplines',
    },
    // A federation's schedule timing (1 Nov 2026).
    TIMING_GET: {
      method: API_METHOD.GET,
      path: '/api/disciplines/{id}/schedule-timing',
    },
    TIMING_PUT: {
      method: API_METHOD.PUT,
      path: '/api/disciplines/{id}/schedule-timing',
    },
    // A federation's regulation for the MSAC mat's clock (1 Nov 2026).
    MAT_REGULATION_GET: {
      method: API_METHOD.GET,
      path: '/api/disciplines/{id}/mat-bout-regulation',
    },
    MAT_REGULATION_PUT: {
      method: API_METHOD.PUT,
      path: '/api/disciplines/{id}/mat-bout-regulation',
    },
    // One record's FSKA / MSAC — an athlete, coach, secretary or referee
    // reached through a profile, whose embedded copy does not carry them.
    OF_RECORD: {
      method: API_METHOD.GET,
      path: '/api/{resource}/{id}',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/disciplines',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/disciplines/{id}',
    },
  },
  RULES: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/rules',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/rules',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/rules/{id}',
    },
    COPY: {
      method: API_METHOD.POST,
      path: '/api/rules/{id}/copy',
    },
    CATEGORY_GROUP: {
      method: API_METHOD.POST,
      path: '/api/rules/{id}/categories/group',
    },
  },
  RULE_CATEGORIES: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/rule_categories',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/rule_categories',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/rule_categories/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/rule_categories/{id}',
    },
  },
  // An application's representatives — the whole list read and written at once (25 Oct 2026).
  APPLICATION_REPRESENTATIVES: {
    GET: { method: API_METHOD.GET, path: '/api/applications/{id}/representatives' },
    PUT: { method: API_METHOD.PUT, path: '/api/applications/{id}/representatives' },
  },
  // A team's representative — a role of a profile, per federation (25 Oct 2026).
  REPRESENTATIVE: {
    POST: { method: API_METHOD.POST, path: '/api/representatives' },
    PATCH: { method: API_METHOD.PATCH, path: '/api/representatives/{id}' },
    DELETE: { method: API_METHOD.DELETE, path: '/api/representatives/{id}' },
  },
  SECRETARY: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/secretaries',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/secretaries',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/secretaries/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/secretaries/{id}',
    },
  },
  SPORTSMEN: {
    // The competitions one athlete has been in — fetched when the chip in the
    // Sportsmen table is pressed, never shipped with the whole collection.
    COMPETITIONS: {
      method: API_METHOD.GET,
      path: '/api/sportsmen/{id}/competitions',
    },
    LIST: {
      method: API_METHOD.GET,
      path: '/api/sportsmen',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/sportsmen',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/sportsmen/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/sportsmen/{id}',
    },
  },
  TEAM: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/competition_teams',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/competition_teams',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/competition_teams/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/competition_teams/{id}',
    },
  },
  TRAINERS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/trainers',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/trainers',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/trainers/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/trainers/{id}',
    },
  },
  // The super admin's exceptions to the FSKA / MSAC split
  // (docs/architecture/discipline-access.md, stage 5).
  ACCESS_GRANTS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/access_grants',
    },
    POST: {
      method: API_METHOD.POST,
      path: '/api/access_grants',
    },
    // Edit, deactivate, activate — nothing deletes a grant (31 Oct 2026).
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/access_grants/{id}',
    },
    // What a grant may name, read for the form's picker.
    TARGETS: {
      method: API_METHOD.GET,
      path: '/api/{collection}',
    },
  },
  ME: {
    // Live identity (id/username/roles/displayName) — never stale, unlike
    // the JWT roles claim the session is bootstrapped from.
    GET: {
      method: API_METHOD.GET,
      path: '/api/me',
    },
  },
  // «Мої татамі»: the signed-in user's competitions and mats as a secretary.
  MY_TATAMI_SESSIONS: {
    GET: {
      method: API_METHOD.GET,
      path: '/api/me/tatami-sessions',
    },
  },
  USER: {
    // A user's oblasts per federation — the regional admin (1 Nov 2026).
    REGIONS_GET: {
      method: API_METHOD.GET,
      path: '/api/users/{id}/regions',
    },
    REGIONS_PUT: {
      method: API_METHOD.PUT,
      path: '/api/users/{id}/regions',
    },
    AUTH_LOGIN: {
      method: API_METHOD.POST,
      path: '/api/authentication_token',
    },
    OWN_PROFILE: {
      method: API_METHOD.GET,
      path: '/api/account/profile',
    },
    REGISTER: {
      method: API_METHOD.POST,
      path: '/api/users',
    },
    // PASSWORD RECOVERY. Both anonymous — somebody who cannot log in cannot
    // present a JWT. The request endpoint answers the same way whatever the
    // address is; the reset endpoint accepts only a token this system issued.
    PASSWORD_RESET_REQUEST: {
      method: API_METHOD.POST,
      path: '/api/password-reset/request',
    },
    PASSWORD_RESET: {
      method: API_METHOD.POST,
      path: '/api/password-reset/reset',
    },
    // VERIFIED EMAIL CHANGE. The request needs a session — it is always
    // about the CALLER'S own account, taken from the token. The confirm does
    // not: it is opened from a mail client that has never logged in.
    EMAIL_CHANGE_REQUEST: {
      method: API_METHOD.POST,
      path: '/api/account/email-change',
    },
    // «Підтвердити» the address the account already has (24 Oct 2026).
    EMAIL_VERIFICATION_REQUEST: {
      method: API_METHOD.POST,
      path: '/api/account/email-verification',
    },
    EMAIL_CHANGE_CONFIRM: {
      method: API_METHOD.POST,
      path: '/api/account/email-change/confirm',
    },
    LIST: {
      method: API_METHOD.GET,
      path: '/api/users',
    },
    CREATE: {
      method: API_METHOD.POST,
      path: '/api/users',
    },
    PATCH: {
      method: API_METHOD.PATCH,
      path: '/api/users/{id}',
    },
    DELETE: {
      method: API_METHOD.DELETE,
      path: '/api/users/{id}',
    },
    COACHES: {
      method: API_METHOD.GET,
      path: '/api/users/coaches',
    },
  },
  ENTITY_CHANGE_LOGS: {
    LIST: {
      method: API_METHOD.GET,
      path: '/api/entity_change_logs',
    },
  },
  COMPETITION_SCHEDULE_SETTINGS: {
    GET: {
      method: API_METHOD.GET,
      path: '/api/competition-settings/{id}',
    },
    SAVE: {
      method: API_METHOD.POST,
      path: '/api/competition-settings',
    },
  },
  SCHEDULE: {
    GET: {
      method: API_METHOD.GET,
      path: '/api/schedule/{id}',
    },
    GENERATE: {
      method: API_METHOD.POST,
      path: '/api/schedule/generate',
    },
    PDF: {
      method: API_METHOD.GET,
      path: '/api/schedule/{id}/pdf',
    },
    PREVIEW_DURATIONS: {
      method: API_METHOD.POST,
      path: '/api/schedule/preview-durations',
    },
    CATEGORIES: {
      method: API_METHOD.GET,
      path: '/api/schedule/categories/{id}',
    },
    MERGE_CANDIDATES: {
      method: API_METHOD.GET,
      path: '/api/schedule/merge-candidates/{id}',
    },
    // The schedule's colours, per competition (31 Oct 2026) — admin or the
    // competition's chief secretary; a locked schedule takes them too.
    // Who is in which category — the schedule page's search (31 Oct 2026).
    ATHLETES_INDEX: {
      method: API_METHOD.GET,
      path: '/api/schedule/{id}/athletes',
    },
    COLORS_GET: {
      method: API_METHOD.GET,
      path: '/api/schedule/{id}/colors',
    },
    COLORS_PUT: {
      method: API_METHOD.PUT,
      path: '/api/schedule/{id}/colors',
    },
    // The schedule's timing of this competition (1 Nov 2026) — the admin's
    // and its chief secretary's.
    TIMING_GET: {
      method: API_METHOD.GET,
      path: '/api/schedule/{id}/timing',
    },
    TIMING_PUT: {
      method: API_METHOD.PUT,
      path: '/api/schedule/{id}/timing',
    },
    TATAMI_PDF: {
      method: API_METHOD.GET,
      path: '/api/schedule/{id}/pdf/tatami/{tatamiId}',
    },
    EXPORT: {
      method: API_METHOD.GET,
      path: '/api/schedule/{id}/export',
    },
    IMPORT_VALIDATE: {
      method: API_METHOD.POST,
      path: '/api/schedule/{id}/import/validate',
    },
    IMPORT: {
      method: API_METHOD.POST,
      path: '/api/schedule/{id}/import',
    },
    CATEGORY_ATHLETES: {
      method: API_METHOD.GET,
      path: '/api/schedule/categories/{id}/athletes/{slotKey}',
    },
    LOCK: {
      method: API_METHOD.POST,
      path: '/api/schedule/{id}/lock',
    },
    UNLOCK: {
      method: API_METHOD.POST,
      path: '/api/schedule/{id}/unlock',
    },
  },
};
